import { KeyValue } from '@angular/common';
import { WeeklySchedule, TimeRange as FedExLocationTimeRange } from '@evorait/pace-core';

export const WEEK_ORDER = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];

/**
 * Utility function to order the key value pairs for FedEx locations time ranges
 * since the response may not come through in the right order
 *
 * @param a the time range to compare to b
 * @param b the time range to compare to a
 * @param weekOrder the actual order of weekdays
 * @returns number for order
 */
export function compareWeekKeys(
    a: KeyValue<string, FedExLocationTimeRange>,
    b: KeyValue<string, FedExLocationTimeRange>,
    weekOrder: string[],
): number {
    return weekOrder.indexOf(a.key) - weekOrder.indexOf(b.key);
}

/**
 * Prepares a weekly schedule for display.
 *
 * - Goes through the days
 * - Skips any day that doesn’t have a valid time range (nulls)
 * - Returns a simple object that will then go through the ordering pipe
 *
 * @param entry The raw weekly schedule from the backend FedEx API
 * @returns An object with only the valid days and their time ranges
 */

export function getWeeklySchedule(entry: WeeklySchedule): Record<string, FedExLocationTimeRange> {
    const schedule: Record<string, FedExLocationTimeRange> = {};
    WEEK_ORDER.forEach((day) => {
        const time = entry[day as keyof WeeklySchedule];
        if (time) {
            schedule[day] = time;
        }
    });
    return schedule;
}
